<!--
  Banner "versi baru tersedia".

  Muncul saat service worker sudah selesai mengunduh versi baru dan menunggu
  giliran. Sengaja BUKAN muat-ulang otomatis: aplikasi ini penuh form (booking
  homecare, pendaftaran, alamat) dan memuat ulang di tengah pengisian akan
  membuang isian orang. Pengguna yang menentukan waktunya.

  Ditutup = hilang untuk sesi ini saja, bukan selamanya. Pembaruannya tetap
  menunggu dan bannernya muncul lagi saat aplikasi dibuka berikutnya — itu
  memang yang diinginkan, jangan disimpan ke localStorage.
-->
<template>
  <div v-if="tampil" class="update-banner" :class="{ 'update-banner--atas-footer': footerVisible }" role="status" aria-live="polite">
    <i class="material-icons update-banner__ikon" aria-hidden="true">system_update_alt</i>

    <div class="update-banner__teks">
      <strong>Versi baru tersedia</strong>
      <span>Muat ulang untuk memakainya.</span>
    </div>

    <button type="button" class="update-banner__aksi" :disabled="sedangMemuat" @click="muatUlang">
      {{ sedangMemuat ? "Memuat…" : "Muat ulang" }}
    </button>

    <button type="button" class="update-banner__tutup" aria-label="Tutup" :disabled="sedangMemuat" @click="tampil = false">
      <i class="material-icons" aria-hidden="true">close</i>
    </button>
  </div>
</template>

<script>
import { pembaruanTertunda, dengarkanPembaruan, terapkanPembaruan } from "@/utils/swUpdate";

export default {
  name: "UpdateBanner",
  props: {
    // Footer setinggi 70px dengan tombol Panggilan Darurat yang menyembul ~20px
    // di atasnya; banner digeser melewati keduanya supaya tidak menutupi tab
    // navigasi. Saat footer disembunyikan (login/register/form), banner turun.
    footerVisible: { type: Boolean, default: true },
  },
  data() {
    return {
      tampil: false,
      sedangMemuat: false,
      lepasPendengar: null,
    };
  },
  mounted() {
    // Pembaruan bisa terdeteksi SEBELUM komponen ini ada — App.vue menahan
    // splash screen 3 detik. Karena itu status tersimpan ditanyakan dulu,
    // baru berlangganan event untuk pembaruan yang datang belakangan.
    if (pembaruanTertunda()) this.tampil = true;
    this.lepasPendengar = dengarkanPembaruan(() => {
      this.tampil = true;
    });
  },
  unmounted() {
    if (this.lepasPendengar) this.lepasPendengar();
  },
  methods: {
    muatUlang() {
      this.sedangMemuat = true;
      terapkanPembaruan();
    },
  },
};
</script>

<style scoped>
.update-banner {
  position: fixed;
  bottom: calc(12px + env(safe-area-inset-bottom, 0px));
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 24px);
  max-width: 456px; /* lebar aplikasi 480px dikurangi jarak kiri-kanan */
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 10px;
  background-color: #548923;
  color: #ffffff;
  font-family: "Lexend", Arial, sans-serif;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);
  /* Footer ber-z-index 999; banner harus di atasnya. */
  z-index: 1000;
}

.update-banner--atas-footer {
  /* footer 70px + tombol darurat menyembul ~20px + jarak 8px */
  bottom: calc(98px + env(safe-area-inset-bottom, 0px));
}

.update-banner__ikon {
  font-size: 22px;
  flex-shrink: 0;
}

.update-banner__teks {
  display: flex;
  flex-direction: column;
  line-height: 1.25;
  min-width: 0;
  flex: 1;
}

.update-banner__teks strong {
  font-size: 13px;
}

.update-banner__teks span {
  font-size: 11px;
  opacity: 0.85;
}

.update-banner__aksi {
  flex-shrink: 0;
  border: 0;
  border-radius: 6px;
  background-color: #ffffff;
  color: #548923;
  font-size: 12px;
  font-weight: 600;
  padding: 7px 12px;
  cursor: pointer;
}

.update-banner__aksi:disabled {
  opacity: 0.7;
  cursor: default;
}

.update-banner__tutup {
  flex-shrink: 0;
  border: 0;
  background: transparent;
  color: #ffffff;
  opacity: 0.8;
  padding: 2px;
  cursor: pointer;
  display: flex;
}

.update-banner__tutup i {
  font-size: 18px;
}
</style>
